import { render, staticRenderFns } from "./ItemsBlock.vue?vue&type=template&id=8dbf9a4e"
import script from "./ItemsBlock.vue?vue&type=script&lang=ts"
export * from "./ItemsBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports